// @flow
const LOCAL_HOST = 'localhost';
const LOCAL_ALIASES = [LOCAL_HOST, '127.0.0.1'];
const ROVER_LOCAL = 'rover.local';
const ROVER_COM = '.rover.com';

const getCookieDomain = (host: string) => {
  if (LOCAL_ALIASES.includes(host)) {
    return LOCAL_HOST;
  }

  if (host === ROVER_LOCAL) {
    return ROVER_LOCAL;
  }

  return ROVER_COM;
};

export default getCookieDomain;



// WEBPACK FOOTER //
// ../utilities/cookie/getCookieDomain.js